import React, { useState } from 'react';
import { Button } from '@/components/ui/Button';

interface ApproveServiceDialogProps {
  open: boolean;
  serviceId: number | null;
  onClose: () => void;
  onApprove: (serviceId: number, isPublic: boolean) => Promise<void>;
}

const ApproveServiceDialog: React.FC<ApproveServiceDialogProps> = ({
  open,
  serviceId,
  onClose,
  onApprove,
}) => {
  const [isPublic, setIsPublic] = useState(false);
  const [loading, setLoading] = useState(false);

  if (!open) return null;

  const handleApprove = async () => {
    if (!serviceId) return;
    setLoading(true);
    try {
      await onApprove(serviceId, isPublic);
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
        <h3 className="text-lg font-semibold mb-4">서비스 승인</h3>
        <p className="text-sm text-gray-600 mb-4">
          이 서비스를 승인하시겠습니까?
        </p>
        <div className="mb-4">
          <label className="flex items-center space-x-2 cursor-pointer">
            <input
              type="checkbox"
              checked={isPublic}
              onChange={(e) => setIsPublic(e.target.checked)}
              className="w-4 h-4 text-primary border-gray-300 rounded focus:ring-primary"
            />
            <span className="text-sm text-gray-700">
              공개 서비스로 설정 (고객사 관리자가 검색 가능)
            </span>
          </label>
        </div>
        <div className="flex gap-2 justify-end">
          <Button
            onClick={onClose}
            variant="outline"
            size="sm"
            disabled={loading}
          >
            취소
          </Button>
          <Button
            onClick={handleApprove}
            size="sm"
            disabled={loading}
          >
            {loading ? '승인 중...' : '승인'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ApproveServiceDialog;

